<template>
<div class="content-head">
  <h1 class="heading-common" v-if="!isExam"><span v-html="lesson.lesson_number + '. ' + lesson.sub_title"></span> <span class="sub-menu-open" :class="{ 'open': isSubmenu }" @click="submenu"></span></h1>
  <h1 class="heading-common" v-else v-html="lesson.sub_title"></h1>
  <template v-if="!isExam">
  <div class="content-head-wrapper" @click.self="submenu" v-show="isSubmenu">
  <transition name="submenuslide" appear>
    <div class="sub-menu-modal" v-show="isSubmenu">
      <div class="sub-menu-grid">
        <div class="sub-menu-item active" @click="movePage('story')" v-if="routeName!='lesson.introduction'">
          <span class="menu-item-icon grammar"></span>
          <span class="menu-item-title">{{ $t('lesson.introduction.title') }}</span>
        </div>
        <div class="sub-menu-item" @click="movePage('grammar')" :class="lessonContent.grammar.status!='incomplete' ? 'active' : ''" v-if="routeName!='lesson.grammar'">
          <span class="menu-item-icon grammar"></span>
          <span class="menu-item-title">{{ $t('lesson.grammar.title') }}</span>
        </div>
        <div class="sub-menu-item" @click="movePage('practice')" :class="lessonContent.practice.status!='incomplete' && isActiveGrammer ? 'active' : ''" v-if="routeName!='lesson.practice' && !isExplanationPractice">
          <span class="menu-item-icon practice"></span>
          <span class="menu-item-title">{{ $t('lesson.question.title') }}</span>
        </div>
        <div class="sub-menu-item" @click="movePage('listening')" :class="lessonContent.listening_practice.status!='incomplete' && isActivePractice ? 'active' : ''" v-if="routeName!='lesson.listening.practice' && !isExplanationListening">
          <span class="menu-item-icon listening"></span>
          <span class="menu-item-title">{{ $t('lesson.listening_practice.title') }}</span>
        </div>
        <div class="sub-menu-item" @click="movePage('script')" :class="lessonContent.script.status!='incomplete' && isActiveScript ? 'active' : ''" v-if="routeName!='lesson.script'">
          <span class="menu-item-icon script"></span>
          <span class="menu-item-title">{{ $t('lesson.script.title') }}</span>
        </div>
      </div>
      <div class="sub-menu-row">
        <div class="sub-menu-item full active" @click="movePage('title')">
          <span class="menu-item-icon title"></span>
          <span class="menu-item-title" v-if="levelLabel != 'n3' && levelLabel != 'n2'">{{ $t('lesson.exam.button.to_session') }}</span>
          <span class="menu-item-title" v-else-if="levelLabel == 'n3' || levelLabel == 'n2'">{{ $t('lesson.exam.button.to_unit') }}</span>
        </div>
      </div>
      <div class="sub-menu-row">
          <div class="sub-menu-close" @click="submenu"></div>
      </div>
    </div>
  </transition>
  </div>
  </template>
</div>
</template>

<script>
  import {appName, api} from "../../config";
  import {mapState} from 'vuex';
  import {mapGetters} from 'vuex';
  export default {
    name: "ContentHead",
    props: {
      section: {
        type: Object,
        required: true
      },
      lesson: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        isSubmenu: false,
        lesson_content: {},
        moviequiz_list: [],
        review_data: {},
        exam_data: {}
      }
    },
    created() {
      this.lesson_content = this.$store.getters.lesson_content
      console.log(this.lesson_content)
    },

    computed: {
      isExam () {
        return this.lesson.lesson_type == 'exam' ? true : false
      },
      lessonContent() {
         return this.lesson_content
      },
      movieQuizList() {
         return this.moviequiz_list
      },
      reviewData() {
         return this.review_data
      },
      examData() {
         return this.exam_data
      },
      routeName() {
         return this.$route.name
      },
      isExplanationPractice() {
        if(this.$route.name == 'lesson.explanation' && 'step' in this.$route.params && this.$route.params['step'] == 'practice') {
          return true
        } else {
          return false
        }
      },
      isExplanationListening() {
        if(this.$route.name == 'lesson.explanation' && 'step' in this.$route.params && this.$route.params['step'] == 'listening_practice') {
          return true
        } else {
          return false
        }
      },
      levelLabel() {
        let userLevel = this.$store.getters.getAuthUser ? this.$store.getters.getAuthUser.level.toLowerCase() : 'n5'
        if (this.$route.name == 'top') {
          return userLevel;
        } else if (this.$route.name == 'top.level') {
          return (this.$route.params.level != undefined) ? this.$route.params.level : 'n4';
        } else {
          const currentSection = this.$store.getters.section_data
          if(currentSection && (currentSection.level == 'N4' || currentSection.level == 'N5')) {
            return currentSection.level.toLowerCase();
          } else if(currentSection && (currentSection.level == 'n3' || currentSection.level == 'N3')) {
            return 'n3';
          } else if(currentSection && (currentSection.level == 'n2' || currentSection.level == 'N2')) {
            return 'n2';
          } else {
            return '';
          }
        }
      },
      
      isActiveGrammer() {
        if(this.lesson_content.grammar.status == 'completed') {
          return true
        } else {
          return false
        }
      },
      
      isActivePractice() {
        if(this.lesson_content.grammar.status == 'completed' 
              && this.lesson_content.listening_practice.status == 'completed') {
          return true
        } else {
          return false
        }
      },
      
      isActiveScript() {
        if(this.lesson_content.grammar.status == 'completed' 
              && this.lesson_content.listening_practice.status == 'completed'
              && this.lesson_content.practice.status == 'completed') {
          return true
        } else {
          return false
        }
      },
    },
    methods: {
      submenu() {
        if(this.isSubmenu) {
          this.isSubmenu = false
        } else {
          this.isSubmenu = true
        }
      },
      movePage(target) {
        const currentHistory = this.$router.history.current
        
        if(target == 'title') {
          this.isSubmenu = false
          this.$router.push({ name: 'region', params: {region: this.section.section} });
        } else if(target == 'story') {
          this.isSubmenu = false
          this.$router.push({name: 'lesson.introduction', params: { lesson_id: this.lesson.lesson_id }});
        } else if(target == 'grammar') {
          this.isSubmenu = false
          this.$router.push({ name: 'lesson.grammar' });
        } else if(target == 'practice') {
          if(this.isActiveGrammer) {
            this.isSubmenu = false
            this.$router.push({ name: 'lesson.practice', params: { lesson_id: this.lesson.lesson_id } });
          }
        } else if(target == 'listening') {
          if(this.isActivePractice) {
            this.isSubmenu = false
            this.$router.push({ name: 'lesson.listening.practice', params: { lesson_id: this.lesson.lesson_id } });
          }
        } else if(target == 'script') {
          if(this.isActiveScript) {
            this.isSubmenu = false
            this.$router.push({ name: 'lesson.script', params: { lesson_id: this.lesson.lesson_id } });
          }
        }
        
      }
    }
  }
</script>